/**
 * Arabic translate - D34DlyM4N(https://github.com/D34DlyM4N)
 * @type Object
 */
const ar = {
  btn: {
    about: 'حول',
    back: 'رجوع',
    cancel: 'الغاء',
    clear: 'مسح',
    copy: 'نسخ',
    cut: 'قص',
    delete: 'حذف',
    edit: 'تعديل',
    forward: 'الى الامام',
    folder: 'مجلد جديد',
    file: 'ملف جديد',
    fullScreen: 'ملء الشاشة',
    grid: 'شبكة',
    paste: 'لصق',
    refresh: 'تحديث',
    submit: 'ارسال',
    table: 'جدول',
    upload: 'رفع',
    uploadSelect: 'اختر الملفات',
    hidden: 'الملفات المخفية',
  },
  clipboard: {
    actionType: 'نوع',
    copy: 'نسخ',
    cut: 'قص',
    none: 'لا شيء محدد',
    title: 'ذاكرة النصوص',
  },
  contextMenu: {
    copy: 'نسخ',
    cut: 'قص',
    delete: 'حذف',
    download: 'تحميل',
    info: 'اختير:',
    open: 'فتح',
    paste: 'لصق',
    properties: 'الخصائص',
    rename: 'اعادة تسمية',
    select: 'اختيار',
    view: 'عرض',
    zip: 'ضغط',
    unzip: 'أستخراج',
    edit: 'تعديل',
    audioPlay: 'تشغيل',
    videoPlay: 'تشغيل',
  },
  info: {
    directories: 'المجلدات:',
    files: 'الملفات:',
    selected: 'أختيرت:',
    selectedSize: 'حجم الملفات:',
    size: 'حجم الملفات:',
  },
  manager: {
    table: {
      date: 'تأريخ',
      folder: 'مجلد',
      name: 'أسم',
      size: 'حجم',
      type: 'نوع',
    },
  },
  modal: {
    about: {
      developer: 'مطور',
      name: 'Laravel File Manager',
      title: 'حول',
      version: 'الإصدار',
    },
    delete: {
      noSelected: 'لا شيء محدد!',
      title: 'حذف',
    },
    newFile: {
      fieldName: 'أسم الملف',
      fieldFeedback: 'الملف موجود!',
      title: 'أنشاء ملف جديد',
    },
    newFolder: {
      fieldName: 'أسم المجلد',
      fieldFeedback: 'المجلد موجود!',
      title: 'انشاء مجلد جديد',
    },
    preview: {
      title: 'عرض',
    },
    properties: {
      disk: 'قرص',
      modified: 'تم التعديل',
      name: 'أسم',
      path: 'مسار',
      size: 'حجم',
      title: 'خصائص',
      type: 'نوع',
      url: 'رابط',
      access: 'التمكن من',
      access_0: 'تم الرفض',
      access_1: 'قراءة فقط',
      access_2: 'اقرا و اكتب',
    },
    rename: {
      directoryExist: 'المجلد موجود',
      fieldName: 'ادخال اسم جديد',
      fieldFeedback: 'اسم خاطئ',
      fileExist: 'الملف موجود',
      title: 'اعادة تسمية',
    },
    status: {
      noErrors: 'لايوجد خطأ!',
      title: 'الحالة',
    },
    upload: {
      ifExist: 'اذا الملف موجود:',
      noSelected: 'لا توجد ملفات مختارة!',
      overwrite: 'اعادة الكتابة!',
      selected: 'المختارة:',
      size: 'الحجم:',
      skip: 'تخطي',
      title: 'رفع الملفات',
    },
    editor: {
      title: 'محرر',
    },
    audioPlayer: {
      title: 'مشغل الاصوات',
    },
    videoPlayer: {
      title: 'مشغل الفيديو',
    },
    zip: {
      title: 'أنشاء أرشيف',
      fieldName: 'أسم الارشيف',
      fieldFeedback: 'الارشيف موجود!',
    },
    unzip: {
      title: 'فك الارشيف',
      fieldName: 'أسم المجلد',
      fieldRadioName: 'أستخراج الى:',
      fieldRadio1: 'الى المجلد الحالي',
      fieldRadio2: 'في مجلد جديد',
      fieldFeedback: 'المجلد موجود!',
      warning: 'تحذير! اذا تشابهت الاسماء, سيتم استبدال الملفات!',
    },
    cropper: {
      title: 'قص',
      apply: 'تطبيق',
      reset: 'اعادة تعين',
      save: 'حفظ',
    },
  },
  notifications: {
    cutToClipboard: 'قص إلى الحافظة!',
    copyToClipboard: 'نسخ إلى الحافظة!',
  },
  response: {
    noConfig: 'الاعدادت غير متوفرة!',
    notFound: 'غير متوفر!',
    diskNotFound: 'القرص غير موجود!',
    pathNotFound: 'مسار غير موجود!',
    diskSelected: 'تم اختيار القرص!',
    // files
    fileExist: 'الملف موجود بالفعل!',
    fileCreated: 'تم إنشاء الملف!',
    fileUpdated: 'تم تحديث الملف!',
    fileNotFound: 'الملف غير موجود!',
    // directories
    dirExist: 'المجلد موجود بالفعل!',
    dirCreated: 'تم أنشاء المجلد!',
    dirNotFound: 'المجلد غير موجود',
    // actions
    uploaded: 'تم تحديث كل الملفات!',
    notAllUploaded: 'بعض الملفات غير المحملة!',
    delNotFound: 'بعض الملفات غير موجودة! تحديث!',
    deleted: 'تم الحذف!',
    renamed: 'أعيدت تسميتها!',
    copied: 'تم النسخ بنجاح!',
    // zip
    zipError: 'خطأ في إنشاء الأرشيف!',
    // acl
    aclError: 'تم الرفض!',
  },
};

export default ar;
